import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MainLayoutService {

  defaultTemplate: BehaviorSubject<boolean>;

  constructor() {
    this.defaultTemplate = new BehaviorSubject(false);
  }
}
